import {
  GET_BUDGET_ANALYTICS_SUCCESS,
  GET_BUDGET_ANALYTICS_FAIL,
} from "../actionTypes";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export default function getBudgetAnalyticsReducer(
  state = initialState,
  action,
) {
  switch (action.type) {
    case "GET_BUDGET_ANALYTICS_REQUEST":
      return { ...state, loading: true, error: null };
    case GET_BUDGET_ANALYTICS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: null,
      };
    case GET_BUDGET_ANALYTICS_FAIL:
      return { ...state, loading: false, error: true };
    default:
      return state;
  }
}
